var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.633,
    height: 21.81,
    viewBox: "0 0 28.633 21.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}.b{fill:#666;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-200.367 -549.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.367 488.19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 61)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.116,61H2.517A2.521,2.521,0,0,0,0,63.517V80.294A2.521,2.521,0,0,0,2.517,82.81h23.6a2.521,2.521,0,0,0,2.517-2.517V63.517A2.521,2.521,0,0,0,26.116,61Zm-.348,1.678-11.4,11.4-11.5-11.4ZM1.678,79.946V63.856l8.08,8.01Zm1.186,1.186,8.085-8.085,2.833,2.809a.839.839,0,0,0,1.184,0l2.762-2.762,8.041,8.041Zm24.091-1.186-8.041-8.041,8.041-8.041Z",
    transform: "translate(0 -61)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.895c52c6ae713d386bcf2138e28a8151.svg";
export { ForwardRef as ReactComponent };